import { PublicKey, SystemProgram } from '@solana/web3.js';

export const GLOBAL = new PublicKey('4wTV1YmiEkRvAtNtsSGPtUrqRYQMe5SKy2uB4Jjaxnjf');
export const SYSTEM_PROGRAM = SystemProgram.programId;
export const PUMP_FUN_ACCOUNT = new PublicKey('Ce6TQqeHC9p8KetsN6JsjHK7UTZk7nasjjnr7XxXp9F1');
export const coingeckoApiSolUrl = `https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd`;
